import { useMemo } from 'react';
import { useWindowSize } from 'react-use';

import { gridBreakpoints } from '../../themes';

type Breakpoint = keyof typeof gridBreakpoints;

type Breakpoints = {
	[K in Breakpoint]: number;
};

const parsedBreakpoints = Object.fromEntries(
	Object.entries(gridBreakpoints).map(([k, v]) => [
		k,
		Number(v.replace('px', ''))
	])
) as Breakpoints;

export const useBreakpoint = (breakpoint: Breakpoint): boolean => {
	const { width } = useWindowSize();

	return useMemo(
		() => parsedBreakpoints[breakpoint] <= width,
		[breakpoint, width]
	);
};
